import {Injectable} from "@angular/core";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "ionic-angular";
import {Api} from "./api";
import {User} from "./user";
import {Poster} from "./poster";
import {Util} from "./util";
import {isMobileQQ} from "./useragent";
import {WeixinQr} from "./weixin_qr";
import {env} from "../config/environment";

declare var WeixinJSBridge;

function genSubTitle(isGlobalGroupBuy: boolean, isDescendingGroupBuy: boolean, isSolo: boolean) {
  let result = "感谢您的支付";
  if (!isGlobalGroupBuy && !isSolo) {
    result += `<br/><br/>`;
    if (isDescendingGroupBuy) {
      result += "在团购结束前，邀请朋友一起参团，以获得更便宜的价格吧";
    } else {
      result += "请关注本团购动态，<br/>达到指定成团人数后，<br/>才会购买成功并发货。";
    }
  }
  return result;
}

@Injectable()
export class Purchase {
  constructor(
    private toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private api: Api,
    public user: User,
    public util: Util,
    public poster: Poster,
    public weixinQr: WeixinQr
  ) {
    setTimeout(() => {
      const MWEB_PAY_CHECK_ORDER_ID = sessionStorage["MWEB_PAY_CHECK_ORDER_ID"];
      if (MWEB_PAY_CHECK_ORDER_ID) {
        delete sessionStorage["MWEB_PAY_CHECK_ORDER_ID"];
        let argArray = JSON.parse(MWEB_PAY_CHECK_ORDER_ID) as any;
        this.joinGroupBuy.apply(this, argArray);
      }
    })
  }

  purchaseCampaign(campaign_id) {
    let self = this;

    return new Promise((resolve, reject) => {
      let originalHash = window.location.hash;
      history.replaceState(null, null, "#");
      return this.api.placeOrder(campaign_id).then((orderMeta) => {
        this.api.collect({
          event: "purchase-attempt",
          attr: { id: campaign_id, price: orderMeta.fee_amount },
        });
        this.api.weixinPayOrder(orderMeta.id).then((orderInfo) => {
          const onWeixinPayOk = () => {
            let loading = self.loadingCtrl.create({
              content: "正在查询订单状态",
            });
            loading.present();
            let orderResolved = false;
            let intervalId = setInterval(() => {
              self.api.getOrderState(orderMeta.id).then((_) => {
                if (orderResolved) {
                  return;
                }
                if (_.stage === 1) {
                  orderResolved = true;
                  clearInterval(intervalId);
                  loading.dismiss();

                  self.alertCtrl
                    .create({
                      title: "支付成功",
                      subTitle: "感谢您的支付，请在订单详情中查看发货信息",
                      buttons: [
                        {
                          text: "好",
                          role: "cancel",
                          handler: () => {
                            window[
                              "auto_activate_retry_campaign_id"
                            ] = campaign_id;
                          },
                        },
                      ],
                    })
                    .present();

                  resolve();

                  // refresh campaign
                  setTimeout(() => {
                    window["refreshCampaign"]();
                  }, 1000);
                  setTimeout(() => {
                    window["refreshMyCampaigns"]();
                  }, 1000);
                }
              });
            }, 1000);
          };

          if (window.location.origin === "http://localhost:8100") {
            // mock success
            history.replaceState(null, null, originalHash);
            onWeixinPayOk();
          }

          const onBridgeReady = () => {
            WeixinJSBridge.invoke("getBrandWCPayRequest", orderInfo, (res) => {
              history.replaceState(null, null, originalHash);
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                onWeixinPayOk();
              } else {
                reject(res);
              }
            });
          };

          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
              );
            }
          } else {
            onBridgeReady();
          }
        });
        // console.log(_);
        // navCtrl.push(AlipayPortalPage, {id: _.id});
        // this.api.purchaseCampaign(campaign_id).then(_ => {
        //   this.toastCtrl.create({
        //     message: "恭喜，购买成功",
        //     duration: 1500,
        //   }).present();
        //   window.location.hash = "/order/" + campaign_id;
        // });
      });
    }).catch((e) => {
      console.error(e);
    });
  }

  joinGroupBuy(
    item_id,
    follow,
    isLastOne = false,
    isDescendingGroupBuy = false,
    isGlobalGroupBuy = false,
    replayCheckOrder = null,
    solo = false
  ) {
    let self = this;

    const showPosterForItem = () => {
      setTimeout(() => {
        this.poster.show(item_id);
      }, 2000);
    };

    const showQrForItem = (url, title) => {
      return this.weixinQr.show(url, title);
    };

    return new Promise((resolve, reject) => {
      let hintDialogPromise = new Promise((resolve) => {
        if (isGlobalGroupBuy || replayCheckOrder || solo) {
          resolve();
          return;
        }
        self.alertCtrl
          .create({
            title: "活动提示",
            subTitle: `本团购活动采用预先付款的形式。${
              isDescendingGroupBuy
                ? "参与活动人数越多，商品单价越低。差额将自动退回您的微信。"
                : "如果团购成功，将为您发货；如果超时未成团，钱款会自动退回您的微信。"
            }`,
            buttons: [
              {
                text: "好",
                handler: () => {
                  resolve();
                },
              },
            ],
          })
          .present();
      });

      hintDialogPromise.then(() => {
        (replayCheckOrder
            ? Promise.resolve(replayCheckOrder.campaign)
            : this.api.createCampaign({itemId: item_id, follow, solo})
        ).then((campaign) => {
          let originalHash = window.location.hash;
          history.replaceState(null, null, "#");
          return (replayCheckOrder
            ? Promise.resolve(replayCheckOrder.orderMeta)
            : this.api.placeOrder(campaign.id)
          ).then((orderMeta) => {
            this.api.collect({
              event: "purchase-attempt",
              attr: { id: campaign.id, price: orderMeta.fee_amount },
            });

            const pollOrderState = (displayLoading, dismissLoading) => {
              displayLoading();
              let orderResolved = false;
              let intervalId = setInterval(() => {
                self.api.getOrderState(orderMeta.id).then((_) => {
                  if (orderResolved) {
                    return;
                  }
                  if (_.stage === 1) {
                    orderResolved = true;
                    clearInterval(intervalId);
                    dismissLoading();
                    if (isLastOne) {
                      this.alertCtrl
                        .create({
                          title: "支付成功",
                          subTitle:
                            "感谢您的支付，本拼团活动已经开团成功，请于订单详情中领取。",
                          enableBackdropDismiss: false,
                          buttons: [
                            {
                              text: "好",
                              role: "cancel",
                              handler: () => {
                                window["auto_activate_retry_campaign_id"] =
                                  campaign.id;
                                showPosterForItem();
                                showQrForItem(_.qr_url, document.title);
                              },
                            },
                          ],
                        })
                        .present();
                    } else {
                      self.alertCtrl
                        .create({
                          title: "支付成功",
                          subTitle: genSubTitle(
                            isGlobalGroupBuy,
                            isDescendingGroupBuy,
                            campaign.is_solo
                          ),
                          enableBackdropDismiss: false,
                          buttons: [
                            {
                              text: "好",
                              handler: () => {
                                new Promise((resolve) => {
                                  if (isGlobalGroupBuy || campaign.is_solo) {
                                    resolve();
                                    return;
                                  }
                                  this.alertCtrl
                                    .create({
                                      title: "分享给朋友",
                                      subTitle: `请点击右上角图标，邀请他们一起来参团，${
                                        isDescendingGroupBuy
                                          ? "以降低单价并获取返现"
                                          : "以尽快达到成团人数，达到成团人数后课程才会激活"
                                      }。`,
                                      enableBackdropDismiss: false,
                                      buttons: [
                                        {
                                          text: "好",
                                          handler: () => {
                                            resolve();
                                          },
                                        },
                                      ],
                                    })
                                    .present();
                                }).then(() => {
                                  showPosterForItem();
                                  showQrForItem(_.qr_url, document.title);
                                  if (!isGlobalGroupBuy) {
                                    setTimeout(() => {
                                      try {
                                        window[
                                          "showGroupBuyPurchaseSuccessfulHint"
                                        ]().then(() => {
                                          window[
                                            "auto_activate_retry_campaign_id"
                                          ] = campaign.id;
                                        });
                                      } catch (e) {
                                        console.warn(e);
                                      }
                                    }, 100);
                                  }
                                });
                              },
                            },
                          ],
                        })
                        .present();
                    }

                    resolve();
                    setTimeout(() => {
                      window.location.hash = `#/campaign/` + _.campaign_id;
                    }, 1000);
                  }
                });
              }, 1000);
            };

            if (!this.util.isWeixin() || !this.util.isAndroidOrIOS()) {
              if (isMobileQQ()) {
                if (replayCheckOrder) {
                  let loading = self.loadingCtrl.create({
                    content: "正在查询订单状态",
                  });
                  pollOrderState(
                    () => {
                      loading.present();
                    },
                    () => {
                      loading.dismiss();
                    }
                  );
                } else {
                  sessionStorage["MWEB_PAY_CHECK_ORDER_ID"] = JSON.stringify([
                    item_id,
                    follow,
                    isLastOne,
                    isDescendingGroupBuy,
                    isGlobalGroupBuy,
                    {campaign, orderMeta},
                  ]);

                  this.doWechatMwebPay(orderMeta.id);
                  setTimeout(() => {
                    this.joinGroupBuy(item_id,
                      follow,
                      isLastOne,
                      isDescendingGroupBuy,
                      isGlobalGroupBuy,
                      {campaign, orderMeta}
                    )
                  }, 1000);
                }
              } else {
                let payOrderQrAlert;
                pollOrderState(
                  () => {
                    payOrderQrAlert = this.showWechatPayOrderQr(orderMeta.id);
                  },
                  () => {
                    payOrderQrAlert.dismiss();
                  }
                );
              }
              return;
            }

            this.api.weixinPayOrder(orderMeta.id).then((orderInfo) => {
              function onBridgeReady() {
                WeixinJSBridge.invoke(
                  "getBrandWCPayRequest",
                  orderInfo,
                  function (res) {
                    history.replaceState(null, null, originalHash);
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      let loading = self.loadingCtrl.create({
                        content: "正在查询订单状态",
                      });
                      pollOrderState(
                        () => {
                          loading.present();
                        },
                        () => {
                          loading.dismiss();
                        }
                      );
                    } else {
                      reject();
                    }
                  }
                );
              }

              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    onBridgeReady,
                    false
                  );
                }
              } else {
                onBridgeReady();
              }
            });
          });
        });
      });
    }).catch(console.warn);
  }

  private showWechatPayOrderQr(orderId) {
    const qrUrl = `${env.server_url}order/get-wechat-pay-order-qr?id=${orderId}`;
    let alert = this.alertCtrl.create({
      cssClass: "wechat-pay-order-qr-wrapper",
      title: "请用<span class='wechat'>微信</span>扫码以完成支付",
      message: `<div><img src='${qrUrl}' alt="poster"/></div><div class="wechat-hint">微信扫一扫直接扫码 或 <br> 将二维码保存到相册或截图后<br>扫一扫从相册扫码<br>如果购买失败，请加严老师微信 17601287228</div>`,
      buttons: [],
    });
    alert.present();
    return alert;
  }

  private doWechatMwebPay(id) {
    this.api.mWebPay({ order_id: id }).then((data) => {
      window.location.href = data.url;
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/purchase.ts